import React from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useDropdownOptions } from "@/hooks/useDropdownOptions";

export default function Website() {
  const { owners, websiteStatuses, websiteCategories } = useDropdownOptions();

  const columns = [
    { key: "title", label: "Update", type: "text", required: true, placeholder: "Product listing or website change" },
    { key: "category", label: "Category", type: "select", options: websiteCategories, width: 180 },
    { key: "owner", label: "Owner", type: "select", options: owners, width: 140 },
    { key: "status", label: "Status", type: "select", options: websiteStatuses, width: 160 },
    { key: "deadline", label: "Deadline", type: "date", width: 160 },
    { key: "notes", label: "Notes", type: "text" },
    { key: "completed", label: "Done", type: "checkbox", width: 80 },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Website Updates"
        title="Site & Storefront"
        description="Product listings and site changes, tracked with deadlines and completion status."
      />
      <ItemsTable
        endpoint="website_updates"
        columns={columns}
        defaultItem={{ title: "", category: "product listing", status: "pending", owner: "", completed: false, notes: "" }}
        testIdPrefix="website"
        emptyLabel="No updates yet."
      />
    </div>
  );
}
